module.exports = __webpack_public_path__ + "static/media/image_5.9f09ac71.png";